import React from 'react'
import ReactDOM from 'react-dom'
import './normalize.css'
import './index.css'
import './moment-locale'
import App from './App'
import 'typeface-roboto'
import { BrowserRouter } from 'react-router-dom'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import muiTheme from './muiTheme/manole'
import registerServiceWorker from './registerServiceWorker'
import { Provider } from 'react-redux'
import { store, persistor } from './store'
import CircularProgress from '@material-ui/core/CircularProgress'
import { PersistGate } from 'redux-persist/integration/react'
import connectionProxy from './api/connectionProxy'
import 'informed-shared/content-styles/dist/gestor.css'
import Media from 'react-media'
import Typography from '@material-ui/core/Typography'
import DevicePlaceholder from './components/DevicePlaceholder'

connectionProxy.getStore(store)

ReactDOM.render(
    <MuiThemeProvider muiTheme={muiTheme}>
      <React.Fragment>
        <Provider store={store}>
          <PersistGate loading={<CircularProgress />} persistor={persistor}>
            <BrowserRouter>
              <Media query={'(min-width: 768px)'}>
                <App />
              </Media>
            </BrowserRouter>
          </PersistGate>
        </Provider>
        <Media query={'(max-width: 767px)'}>
          <DevicePlaceholder />
        </Media>
      </React.Fragment>
    </MuiThemeProvider>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js